import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ShieldFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.0172 22C12.1872 22 12.4365 21.9293 12.6844 21.8033C18.3839 18.7289 20.2053 17.3154 20.2053 13.7839V6.15794C20.2053 5.0972 19.7828 4.75849 18.9034 4.39883C17.5907 3.86792 14.1329 2.59457 12.8291 2.14601C12.5621 2.05565 12.2892 2 12.0172 2C11.7364 2 11.4635 2.06456 11.1964 2.14601C9.88774 2.58786 6.43485 3.87681 5.12216 4.39883C4.24276 4.74559 3.82031 5.0972 3.82031 6.15794V13.7839C3.82031 17.3154 5.73386 18.5624 11.3501 21.8033C11.5891 21.9382 11.8383 22 12.0172 22ZM10.8925 16.5178C10.5844 16.5178 10.3417 16.3989 10.1079 16.0858L7.46308 12.878C7.3353 12.7066 7.25203 12.5044 7.25203 12.2934C7.25203 11.893 7.56414 11.5582 7.96931 11.5582C8.21998 11.5582 8.4221 11.6504 8.63805 11.9416L10.8569 14.7242L15.3465 7.57017C15.5139 7.30566 15.7467 7.16094 15.9885 7.16094C16.3718 7.16094 16.7374 7.43253 16.7374 7.84265C16.7374 8.04572 16.6265 8.25677 16.5205 8.42911L11.6365 16.0858C11.4561 16.3771 11.2006 16.5178 10.8925 16.5178Z"
        fill={color}
      />
    </svg>
  );
};

export { ShieldFilledSvg };
